module.exports = __webpack_public_path__ + "img/C08TechCarryingBaskets_ua.e4d27593.webp";